import { useContext } from 'react';
import { AuthContext } from '../contexts/MockAuthContext';

export const useAuth = () => {
  // Currently using MockAuthContext for development
  // When AWS Cognito is ready, we'll switch to the real AuthContext
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};